import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import auto from "../../../assets/login_page_assets/images/check-auto-blanc.png";
import lock from "../../../assets/login_page_assets/images/lock.avif";
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import Footer from '../../../Layouts/Footer';
import { useTranslation } from 'react-i18next';

const LockScreen = () => {
    const { t } = useTranslation();
    document.title = `Fleet Fix - ${t('lockScreen.lockedTitle')}`;
    
    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

    return (
        <React.Fragment>
            <div className="auth-page-content">
                <div className="auth-page-wrapper">
                    <div className="auth-page-content" style={{ backgroundImage: `url(${lock})`, backgroundSize: 'cover', height: '100vh' }}>
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <div className="text-center mt-sm-5 mb-4">
                                        <div>
                                            <img src={auto} alt="" height="100" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="justify-content-center">
                                <Col md={8} lg={6} xl={5}>
                                    <Card className="mt-4">
                                        <CardBody className="p-4">
                                            <div className="text-center mt-2">
                                                <h5 className="text-primary">{t('lockScreen.lockedText')}</h5>
                                            </div>
                                            <div className="user-thumb text-center">
                                                <Avatar size={64} icon={<UserOutlined />} />
                                                <h5 className="font-size-15 mt-3">{currentUser?.fullName}</h5>
                                            </div>
                                            <div className="p-2 mt-4">
                                                <form>
                                                    <div className="mb-3">
                                                        <label className="form-label" htmlFor="userpassword">{t('lockScreen.passwordLabel')}</label>
                                                        <input type="password" className="form-control login-fc" id="userpassword" placeholder={t('lockScreen.passwordPlaceholder')} required />
                                                    </div>
                                                    <div className="mb-3 mt-4">
                                                        <Button  className="btn btn-soft-success w-100 login-fc" type="submit">
                                                            <Link to="/dashboard">{t('lockScreen.unlockButton')}</Link>
                                                        </Button>
                                                    </div>
                                                </form>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <div className="mt-4 text-center">
                                        <p className="mb-0 text-white">{t('lockScreen.notMeMessage')} <Link to="/login" className="fw-semibold text-primary text-decoration-underline">{t('lockScreen.loginLink')}</Link></p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        </React.Fragment>
    );
};

export default LockScreen;
